import { InjectionToken, ValueProvider } from '@angular/core';
import { AppConfigModel } from './app-config.model';

export const APP_CONFIG = new InjectionToken<AppConfigModel>('santander app config');

export const provideAppConfig = (value: AppConfigModel): ValueProvider => ({
  provide: APP_CONFIG,
  useValue: value
});
